import { render } from "./PeopleEmpty.vue?vue&type=template&id=057e6def&scoped=true"
import script from "./PeopleEmpty.vue?vue&type=script&lang=js"
export * from "./PeopleEmpty.vue?vue&type=script&lang=js"

import "./PeopleEmpty.vue?vue&type=style&index=0&id=057e6def&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-057e6def"]])

export default __exports__